import React from 'react'
import './style/App.css'

const Testo=()=>(
    <h1 className="text-center"> 
        Whoops! 404 Not found
    </h1>
)

export default Testo


// WEBPACK FOOTER //
// ./src/testo.js